// OperationSchedulerDetailModal.jsx
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import ShortDateFormat from '../components/ShortDateFormat'; // optional; remove if you don't use it

const OperationSchedulerDetailModal = ({ isOpen, onClose, operation, onEdit, edit=true }) => {
  const formatTimeTo12Hour = (time24) => {
    if (!time24) return '';
    const [hh, mm] = time24.split(':');
    let h = parseInt(hh, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return `${h}:${mm} ${ampm}`;
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-screen items-center justify-center p-4">
              <Dialog.Panel className="mx-auto max-w-xl w-full bg-white rounded-lg p-6 shadow-lg">
                <Dialog.Title className="text-lg font-medium text-gray-900">
                  Operation Details
                </Dialog.Title>

                {operation && (
                  <div className="mt-4 space-y-4">
                    <div>
                      <p className="text-sm font-medium text-gray-700">Operation ID:</p>
                      <p className="text-gray-900">{operation.id || operation.schedule_id}</p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-700">Description:</p>
                      <p className="text-gray-900">{operation.description || '—'}</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <p className="text-sm font-medium text-gray-700">Start Date:</p>
                        <p className="text-gray-900">
                          {operation.schedule_from ? (
                            <ShortDateFormat date={operation.schedule_from} />
                          ) : (
                            operation.schedule_from || '—'
                          )}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-700">End Date:</p>
                        <p className="text-gray-900">
                          {operation.schedule_to ? (
                            <ShortDateFormat date={operation.schedule_to} />
                          ) : (
                            operation.schedule_to || '—'
                          )}
                        </p>
                      </div>
                    </div>

                    <div>
                      <p className="text-sm font-medium text-gray-700">Scheduled Time:</p>
                      <p className="text-gray-900">
                        {operation.start_time ? formatTimeTo12Hour(operation.start_time) : 'No Time'}{' '}
                        – {operation.end_time ? formatTimeTo12Hour(operation.end_time) : 'No Time'}
                      </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <p className="text-sm font-medium text-gray-700">Status:</p>
                        <p className="text-gray-900">{operation.status || '—'}</p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-700">Tech:</p>
                        <p className="text-gray-900">
                          {operation.tech_name || '—'}
                          {operation.tech_id ? ` (ID ${operation.tech_id})` : ''}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <p className="text-sm font-medium text-gray-700">Logged:</p>
                        <p className="text-gray-900">
                          {operation.date || '—'} {operation.time_log || ''}
                        </p>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-700">User:</p>
                        <p className="text-gray-900">{operation.user || '—'}</p>
                      </div>
                    </div>

                    <div>
                      <p className="text-sm font-medium text-gray-700">Tech Notes:</p>
                      <p className="text-gray-900 whitespace-pre-line">
                        {operation.tech_notes || '—'}
                      </p>
                    </div>

                    <div>
                      <p className="text-sm font-medium text-gray-700">Coordinator Instructions:</p>
                      <p className="text-gray-900 whitespace-pre-line">
                        {operation.user_comment || '—'}
                      </p>
                    </div>
                  </div>
                )}

                <div className="mt-6 flex justify-end space-x-2">
                  <button
                    type="button"
                    onClick={onClose}
                    className="inline-flex justify-center rounded-md border border-transparent bg-gray-300 px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-400"
                  >
                    Close
                  </button>
                  {edit && (
                  <button
                    type="button"
                    onClick={onEdit}
                    className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    Edit
                  </button>   
                  )}               
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default OperationSchedulerDetailModal;
